import PropTypes from 'prop-types';
import { Component } from 'react';

/**
 * @desc Base Component Interface is our attempt at an interface. Below are the recommended categories to use when a builder
 * passes props to a component. All components will extend this Interface until we know more about interface v composition v HoC
 * @returns {Null} This method is overwritten by its implementors.
 */
class BaseComponentInterface extends Component {

    /**
     * Method to get the properties for the component.
     * @returns {Array} - name spaced properties.
     */
    getProperties = () => {
        const {
            elementProps,
            contentProps,
            visualProps,
            eventProps,
            dataProps,
            stateProps
        } = this.props;

        return [
            elementProps || {},
            contentProps || {},
            visualProps || {},
            eventProps || {},
            dataProps || {},
            stateProps || {}
        ];
    };

    render = () => {
        return null;
    };

}

BaseComponentInterface.propTypes = {

    /**
     * Properties specific for a native DOM element
     * Examples:
     *      - Tag name (button, a, h1, h2, h3, h4, ...etc).
     *      - id
     *      - selected
     *      - disabled
     *      - placeholder
     *      - title...
     * @type {Object}
     */
    elementProps: PropTypes.object,

    /**
     * Any content property supported by the component
     * Examples:
     *      - label (any text content)
     *      - Icon
     *      - Icon position
     *      - Prefix and suffix
     * @type {Object}
     */
    contentProps: PropTypes.object,

    /**
     * Any visual property supported by the component
     * Examples:
     *      - Variant
     *      - color
     *      - size
     *      - UIComponent (a set of traits for a themed component)
     * @type {Object}
     */
    visualProps: PropTypes.object,

    /**
     * Custom functionality for event handlers.
     * The events props will receive an string with the name of the action to be dispatched.
     * Examples:
     *       - onClick handler (submit data to external party before going to confirmation page).
     * @type {Object}
     */
    eventProps: PropTypes.object,

    /**
     * Data properties used by the component.
     * @type {Object}
     */
    dataProps: PropTypes.object,

    /**
     * State properties used by the component.
     * Examples:
     *       - product (a single product object)
     * @type {Object}
     */
    stateProps: PropTypes.object

    /**
     * Allow extra props for plugins like calendar
     */
    // pluginProps: PropTypes.object,
    /**
     * Flag props to toggle things like the label eg v3/address.tag. Might be made redundant
     */
    // flagProps: PropTypes.object
};

export { BaseComponentInterface };
